import { render, staticRenderFns } from "./Fast.vue?vue&type=template&id=02136108"
import script from "./Fast.vue?vue&type=script&lang=js"
export * from "./Fast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports